import type { BodyRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { KudoContentObjectDetailDataObject } from 'models/service';

type CreateKudoRequest = { kudo: Kudo };

type Kudo = {
  attachments?: Array<{ id: string }>;
  community_id?: string;
  html_content: string;
  pinned?: boolean;
  publish_at?: string;
  text_content: string;
  user_id: string;
};

export const createKudo = async ({ body }: BodyRequest<CreateKudoRequest>) =>
  apiClient.post<KudoContentObjectDetailDataObject, ApiClientResponse<KudoContentObjectDetailDataObject>>(
    routes.kudos.create,
    body,
  );
